import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ppl-loading-ellipsis',
    templateUrl: './loading-ellipsis.component.html',
    styleUrls: ['./loading-ellipsis.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PplLoadingEllipsisComponent {
}
